"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _jsCookie = _interopRequireDefault(require("js-cookie"));
var _uuid = require("uuid");
var _consentUtil = require("./consents/consentUtil");
var _constants = require("./constants");
var _cookiesUtil = require("./cookiesUtil");
var _sessionUtil = _interopRequireDefault(require("./sessionUtil"));
function generateUser() {
  var cookieDomain = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _cookiesUtil.TYPEFORM_DOMAIN;
  var user = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (0, _uuid.v4)();
  if ((0, _consentUtil.hasPerformanceConsent)()) {
    _jsCookie["default"].set(_constants.ATTRIBUTION_COOKIE_NAME, user, {
      expires: 365,
      domain: cookieDomain,
      sameSite: 'None',
      secure: true
    });
    _sessionUtil["default"].createOrUpdate(cookieDomain);
  }
  return user;
}
function getUserId() {
  var currentUser = _jsCookie["default"].get(_constants.ATTRIBUTION_COOKIE_NAME);
  if (currentUser) {
    return currentUser;
  }
  return attributionUtil.generateUser();
}
var attributionUtil = {
  generateUser: generateUser,
  getUser: getUserId
};
var _default = exports["default"] = attributionUtil;